// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JDz5z","top":"styles_top__3wchV"};